import { render, staticRenderFns } from "./TheArticles.vue?vue&type=template&id=db5c7b00&"
import script from "./TheArticles.vue?vue&type=script&lang=js&"
export * from "./TheArticles.vue?vue&type=script&lang=js&"
import style0 from "./TheArticles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports